import { useState } from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import style from './CareerList.module.scss';

export type CareerListItemType = {
  title: string;
  detail: string;
};
export type CareerListType = {
  list: CareerListItemType[];
};
export const CareerList = ({ list }: CareerListType): JSX.Element => {
  const [openItems, setOpenItems] = useState<string[]>([]);
  const onAccordionChange = (uuids: string[]) => {
    setOpenItems(uuids);
  };
  return (
    <div className={style.container}>
      <Accordion onChange={onAccordionChange} allowZeroExpanded>
        {list.map((item, index) => {
          const uuid = `item-${index}`;
          const isOpen = openItems.includes(uuid);
          return (
            <AccordionItem key={index} uuid={uuid} className={style.accordionItem}>
              <AccordionItemHeading>
                <AccordionItemButton>
                  <p className={style.accordionItemTitle}>{item.title}</p>
                  <p className={style.accordionItemToggle}>
                    {!isOpen ? `More information` : `Show less`}
                  </p>
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel className={style.accordionItemPanel}>
                <div
                  className={style.accordionItemContent}
                  dangerouslySetInnerHTML={{ __html: item.detail }}
                />
              </AccordionItemPanel>
            </AccordionItem>
          );
        })}
      </Accordion>
      {/* {list.map((career) => {
        return <p>{career.title}</p>;
      })} */}
    </div>
  );
};
